import { createJSONRequest } from '../../../api/create-request.js'

export const fetchEcosystemMaps = () => {
  return createJSONRequest({
    method: 'GET',
    url: '/api/settings/ecosystem-maps',
  })
}

export const fetchEcosystemMap = (id: number) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/settings/ecosystem-maps/${id}`,
  })
}

export const createEcosystemMap = (mapData: object) => {
  return createJSONRequest({
    method: 'POST',
    url: '/api/settings/ecosystem-maps',
    data: mapData,
  })
}

export const updateEcosystemMap = (id: number, mapData: object) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/ecosystem-maps/${id}`,
    data: mapData,
  })
}

export const deleteEcosystemMap = (id: number) => {
  return createJSONRequest({
    method: 'DELETE',
    url: `/api/settings/ecosystem-maps/${id}`,
  })
}

export const updateEcosystemMapStatus = (id: number, status: string) => {
  return createJSONRequest({
    method: 'PUT',
    url: `/api/settings/ecosystem-maps/${id}/status`,
    data: { status },
  })
}

export const fetchEcosystemMapEmbedData = (id: number, apiKey: string) => {
  return createJSONRequest({
    method: 'GET',
    url: `/api/ecosystem-maps/${id}?key=${apiKey}`,
  })
}

export const trackEcosystemMapView = (id: number, apiKey: string) => {
  return createJSONRequest({
    method: 'POST',
    url: `/api/ecosystem-maps/${id}/track-view?key=${apiKey}`,
  })
}
